export class PreviewBackupPolicyResourcesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resources",
            "baseName": "resources",
            "type": "Array<InventoryResource>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        },
        {
            "name": "totalSourceStorageSizeBytes",
            "baseName": "totalSourceStorageSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return PreviewBackupPolicyResourcesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
